export const AI_NOTES_THRESHOLDS = {
  // Rate shop analysis - 20% change threshold
  RATE_SHOP_ALERT_PERCENTAGE: 0.2,

  // Change in sold rooms - 5% of capacity threshold.
  // Does NOT apply to OOO, which is always reported when non-zero (RM-2324).
  KEY_METRICS_ALERT_PERCENTAGE: 0.05,
} as const;

export const ALERT_MESSAGE_TEMPLATES = {
  OOO_ROOMS: 'OOO rooms for next 5 days: {details}',
  DAILY_CHANGE: 'Daily change in sold rooms for next 5 days: {details}',
  // Monday meetings report the 3-day delta, since the last snapshot the team
  // saw was Friday's. Mirrors the "Since Friday" wording used for new groups.
  SINCE_FRIDAY_CHANGE: 'Change in sold rooms since Friday for next 5 days: {details}',
} as const;
